export default {
  modalName: ''
};
